export default __webpack_public_path__ + "static/media/logo_text.759e08de.png";